import { useContext, useEffect, useRef, useState } from "react"
import "./Invoices.css"
import { LocaleContext, LoginContext } from "../common/App"
import { LoadState, MediationStatus, UploadInputState } from "../common/enums.mjs";
import { ErrorComp, Loading, UploadInput } from "../common/Common";
import { ConsumerContext } from "..";
import { compareMediationStatus, getDateStr } from "../common/util";
import { useAutoLoad } from "../common/hooks";

export const Invoices = ({}) => {
    const locale = useContext(LocaleContext);
    const consumer = useContext(ConsumerContext);

    const [invoices, setInvoices] = useState(null);

    const mediationStatusRef = useRef(consumer.mediationStatus);


    // EFFECTS:

    useEffect(() => {
        mediationStatusRef.current = consumer.mediationStatus;
    }, [consumer.mediationStatus]);

    const [loadState, setLoadState] = useAutoLoad((json) => {
        // On load success
        setInvoices(json);

        // setLoadState(LoadState.LOADING); // For testing
    }, () => {
        // On load error
    }, () => {
        // On before load

        // if(!compareMediationStatus(mediationStatusRef.current, MediationStatus.PROTECTION_FEE_INVOICE_AVAILABLE)) {
        //     return null;
        // }

        return "/user/get_invoices";
    });


    // RENDER:

    let invoiceEles = [];

    if(invoices && Object.keys(invoices).length > 0) {
        for(let [k, v] of Object.entries(invoices)) {
            
            let translatedName = "unknown";

            if(k === "protection_fee") {
                translatedName = locale.msgs.PROTECTION_FEE;
            }
            else if(k === "mediation_fee") {
                translatedName = locale.msgs.MEDATION_FEE;
            }

            if(v.skipped === true) {
                invoiceEles.push(
                    <div className={"invoice_box" + ((invoiceEles.length === 0) ? " invoice_box_first" : "")}>
                        {/* <div className="text_big_3">{translatedName}</div> */}

                        <div className="text_2">{k === "protection_fee" ? locale.msgs.PROTECTION_FEE_SKIPPED_DESCR : (k === "mediation_fee" ? locale.msgs.MEDIATION_FEE_SKIPPED_DESCR : "")}</div>
                    </div>
                );
            }
            else {
                let paidDateStr;

                if(v.paid_date && v.paid_date !== "") {
                    paidDateStr = getDateStr(v.paid_date);
                }

                invoiceEles.push(
                    <div className={"invoice_box" + ((invoiceEles.length === 0) ? " invoice_box_first" : "")}>
                        {/* <div className="text_big_3">{translatedName}</div> */}

                        <div className={"invoices_upload_input"}>
                            <UploadInput name={translatedName} filename={v.name}
                                    editable={false} state={UploadInputState.UPLOADED}
                                    url={v.url}
                                    removeBtnPresent={false}
                                    removable={false}
                            />

                            { paidDateStr ? 
                                <div className="document_share_suc_box">
                                    <img className="passing_released_img" src="/common/icon_done_green.svg"></img>
                                    <div className="passing_released_img_text text_success_2">
                                        { k === "protection_fee" ?
                                            (locale.msgs.PROTECTION_FEE_PAID_ON ? locale.msgs.PROTECTION_FEE_PAID_ON.replace("{{datetime}}", paidDateStr) : "")
                                        : k === "mediation_fee" ?
                                            (locale.msgs.MEDIATION_FEE_PAID_ON ? locale.msgs.MEDIATION_FEE_PAID_ON.replace("{{datetime}}", paidDateStr) : "")
                                        :
                                            null
                                        }
                                    </div>
                                </div>

                            :
                                null
                            }
                        </div>
                    </div>
                );
            }
        }
    }
    else {
        invoiceEles = <div className="text_2">{locale.msgs.NO_OPEN_INVOICES}</div>;
    }

    return (
        <div className="invoices">
            { loadState === LoadState.LOADING ?
                <div className="invoices_loading">
                    <Loading />
                </div>
            :
                loadState === LoadState.LOAD_ERROR ?
                    <ErrorComp text={locale.msgs.GENERAL_ERROR_DESCR} noTopMargin={true} />
                :
                    <div>
                        {invoiceEles}
                    </div>
            }
        </div>
    );
}
